import { Flex, Text } from '@huspy/briks-web';
import { Image, Skeleton } from '@mantine/core';
import { AMPLITUDE_FEATURE_FLAGS, CreditsPriceListActionName } from '@modules/core/api/types';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { imagesPath } from '@shared/css.const';
import useGetCreditsPriceList from '@modules/core/hooks/queries/useGetCreditsPriceList';

type Props = {
  action_type: CreditsPriceListActionName;
  color?: string;
  isDisabled?: boolean;
  showLeftLine?: boolean;
};

const CreditsCharge = ({
  action_type, color, isDisabled, showLeftLine = true,
}: Props) => {
  const { featureFlags } = useFeatureFlags();

  const CLIENT_HUB_CREDITS_MODULE = featureFlags?.[AMPLITUDE_FEATURE_FLAGS.CLIENT_HUB_CREDITS_MODULE];
  const { isLoading, getActionPrice } = useGetCreditsPriceList(CLIENT_HUB_CREDITS_MODULE);

  if (!CLIENT_HUB_CREDITS_MODULE) {
    return <></>;
  }

  return (
    <Flex direction='row' gap={ 2 } data-testid='credit-charge'>
      {
        showLeftLine ? (
          <Text color={ color }>|</Text>
        ) : null
      }

      <Flex style={ { width: '16px' } }>
        <Image
          src={ `${imagesPath}/credits.png` }
          w={ 16 }
          style={ { opacity: isDisabled ? '0.2' : '1' } }
        />
      </Flex>

      {
        isLoading
          ? (<Skeleton w='100%' height='20px' radius='12px' data-testid='credit-amount-skeleton' />)
          : (
            <Text color={ color }>
              {Math.abs(getActionPrice(action_type) ?? 0)}
            </Text>
          )
      }
    </Flex>
  );
};

export default CreditsCharge;
